module.exports = __webpack_public_path__ + "img/Bosnia and Herzegovina.c3ca8487.svg";